import http from "@/utils/httpService";

export const AuthApi = data => http.Axios.get("/admin/menu", data); //权限获取菜单
export const LogoutApi = data => http.Axios.delete("/auth/token/logout", data); //退出登录

export const AccessTokenRefreshApi = data =>
  http.Axios.post("/accessToken/refresh", data); //刷新登录令牌接口
export const ResetPassWordApi = data => http.Axios.post("/user/password", data); //修改密码

export const CheckLoginApi = data =>
  http.Axios.get("/admin/user/checkLogin", data);
export const GetChinaAddressDataTotalApi = data =>
  http.Axios.post("administrativeArea/areaJson", data); //全国地址数据

export const FindReportUrlApi = data =>
  http.Axios.get(
    `/finalVersionReport/findReportUrl/${data.caseId}/${data.type}`
  ); //附件下载

export const traceLogPageApi = data => http.Axios.post("/traceLog/page", data); //查询前端日志

export const DicsQueryDicsApi = data =>
  http.Axios.post("/dics/queryDics", data); //字典查询
export const getLastLoginMessage = data =>
  http.Axios.get(`/admin/loginRecordLog/getLastLoginMessage`, data);
